export const GET_USERS = "GET_USERS";
export const GET_VEHICLES = "GET_VEHICLES";
export const GET_SELECTVEHICLES = "GET_SELECTVEHICLES";
export const GET_CLAIMS = "GET_CLAIMS";
export const GET_IDSELECT = "GET_IDSELECT";
export const GET_IDUSER = "GET_IDUSER";
